import axios from "axios";
import {
  EXPLORE_SIP_DATA,
  GET_CARD,
  NACH_SEND_OTP,
  NACH_VERIFY_OTP,
  PROCEED_CARD,
  PURCHASE_CART,
} from "./types";
import { getLocalStorageUserToken } from "../utils/userData";
import { toast } from "react-toastify";
import axiosInstance from "../api/axios";
import { getHeaderCount } from "./notificationAction";
const token = getLocalStorageUserToken();

export const getCards = (payload) => {
  return async (dispatch) => {
    try {
      // if (payload?.id) {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}cart/show`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      dispatch({ type: GET_CARD, payload: response.data }); // Ensure `response.data` has the correct format
      // }
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
    }
  };
};

export const cartProceed = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}cart/proceed`,
        {
          products_in_cart: payload.products_in_cart,
          client_code: payload.client_code,
          mandate_id: payload.mandate_id,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      dispatch({ type: PROCEED_CARD, payload: response.data }); // Ensure `response.data` has the correct format
      return response?.data;
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
      return error;
    }
  };
};

export const exploreSipData = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}explore-funds/sip-data?scheme_code=${payload?.scheme_code}&sip_frequency=${payload?.sip_frequency}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      dispatch({ type: EXPLORE_SIP_DATA, payload: response.data }); // Ensure `response.data` has the correct format
      return response?.data;
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
      return error;
    }
  };
};

export const nachSendOtp = (payload) => {
  return async (dispatch) => {
    try {
      console.log("payloadpayloadpayloadpayload", payload)
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}explore-funds/nach-verify-otp?userid=${payload}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response?.data?.status == true) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
      dispatch({ type: NACH_SEND_OTP, payload: response.data }); // Ensure `response.data` has the correct format
      return response?.data;
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
    }
  };
};

export const nachVerifyOtp = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}explore-funds/trxn-verify-otp`,
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      dispatch({ type: NACH_VERIFY_OTP, payload: response.data }); // Ensure `response.data` has the correct format
      return response?.data;
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
    }
  };
};

export const purchaseCart = (payload, type) => {
  return async (dispatch) => {
    try {
      const payloadRequire = {
        amt: payload?.amt,
        id: payload?.id,
        mandate_id: payload?.mandate_id,
        no_netbanking: payload?.no_netbanking,
        no_upi: payload?.no_upi,
        payment_mode: payload?.payment_mode,
        proceed: payload?.proceed,
      };
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}cart/buy`,
        payloadRequire,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const orderId = [];
      if (response?.data?.transactions?.sip?.length > 0) {
        for (const sipData of response?.data?.transactions?.sip) {
          orderId?.push(sipData?.reg_id);
        }
      }

      if (response?.data?.transactions?.lumpsum?.length > 0) {
        for (const lumpsumData of response?.data?.transactions?.lumpsum) {
          orderId?.push(lumpsumData?.trxn_order_id);
        }
      }

      if (orderId?.length > 0) {
        const payloadProceed = {
          payment_mode: payload?.payment_mode,
          order_ids: orderId?.join(","),
          client_code: payload?.client_code,
          amount: payload?.amt,
          ...((payload?.payment_mode === "NACH" || payload?.payment_mode === "MANDATE") && {
            mandate_id: payload?.mandate_id,
          }),
          ...(payload?.payment_mode === "CHEQUE" && {
            bank_account_no: payload?.bank_account_no,
            ifsc: payload?.ifsc,
            cheque_no: payload?.cheque_no,
            cheque_date: payload?.cheque_date,
          }),
          ...(payload?.payment_mode === "UPI" && {
            bank_account_no: payload?.bank_account_no,
            ifsc: payload?.ifsc,
            upi_id: payload?.upi_id,
          }),
          ...(payload?.payment_mode === "OL" && {
            bank_account_no: payload?.bank_account_no,
            ifsc: payload?.ifsc,
          }),
        };
        if (type !== "s") {
          const response = await axiosInstance.post(
            `${process.env.REACT_APP_API_URL}cart/proceed-payment`,
            payloadProceed,
            {
              headers: {
                Authorization: `${token}`,
              },
            }
          );
          if (response) {
            dispatch(getHeaderCount());
          }

          dispatch({ type: PURCHASE_CART, payload: response.data }); // Ensure `response.data` has the correct format
          return response?.data;
        } else {
          if (response) {
            dispatch(getHeaderCount());
          }
          dispatch({ type: PURCHASE_CART, payload: response.data }); // Ensure `response.data` has the correct format
          return response?.data;
        }
      } else {
        dispatch({ type: PURCHASE_CART, payload: response.data }); // Ensure `response.data` has the correct format
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
    }
  };
};
